import apiClient2 from "@/shared/api/apiClient2";

export const getTemplateFieldList = async (params) => {
  try {
    const { data } = await apiClient2.get(
      "/templates/notary_transactions/fields/",
      {
        params,
      }
    );
    return data;
  } catch (e) {
    console.error("getTemplateFieldList failed", e);
  }
};
